<template>
<div class="container">
  <div class="row">
    <div class="col-md-6 offset-md-3">
      <div class="alert alert-info" role="alert">
        {{ response }}
      </div>
    </div>
  </div>
  <button class="btn btn-primary" @click="next">Next Question</button>
</div>
</template>

<script>
  
export default {
  name: 'ResponseMaster',
  props: {
    response: {
      type: String,
      required: true
    }
  },
  methods: {
    next() {
      this.$emit('next')
    }
  }
}
</script>
<style scoped>
  .alert {
    margin-top: 60px;
    font-size: 1.1rem;
  }
  .alert-info {
    color: #fff;
    background-color: rgba(0, 0, 0, .2);
    border-color: rgba(0, 0, 0, .3);
  }
  .btn-primary {
    background-color: #000000;
    color: rgb(253, 255, 0);
    border: none;
    border-radius: 20px;
    padding: 5px 15px;
    text-align: center;
  }
  .btn-primary:hover,
  .btn-primary:focus {
    background-color: #000000;
    color: rgb(253, 255, 0);
    border: #fff;
  }
</style>
